import styled from "styled-components";
import { RollFromBottom } from "../ui/animations";

const Text = styled.p`
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: normal;
  line-height: 25px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  max-width: 350px;
  animation: ${RollFromBottom} 1.75s ease;
  @media screen and (max-width: 600px) {
    font-size: 12px;
  }
  @media screen and (max-width: 400px) {
    font-size: 11px;
    width: 100%;
  }
`;

export default Text;
